
var stringUtil = require('../../../utils/string/stringUtil');
var dateUtil = require('../../../utils/dateUtil/dateUtil');
var formatter = require('../../../utils/formatter/formatter');
var saleCalculator = require('../../../utils/domain/sales/saleCalculator');
var storefrontUtility = require('../../../utils/domain/storefrontUtility');
var constants = require('../../../utils/domain/constants');
var localizationUtils = require('../../../utils/domain/localizationUtils');
var printUtil = require('../../../utils/print/printUtil');
var logger = require('../../../utils/logger/logger');
var saleEndorsementUtils = require('../../../utils/domain/externalIntegrations/endorsements/saleEndorsementUtils')
var receiptEndorsementUtils = require('../../../utils/domain/externalIntegrations/endorsements/receiptEndorsementUtils')

export async function printSaleCustomerReceipt(sale, numberOfCopies)
{
    try
        {
            var receiptPrintPayload = {};
        
            receiptPrintPayload.quantity = numberOfCopies;
            receiptPrintPayload.operator = sale.operator;
            receiptPrintPayload.server = sale.server;
            receiptPrintPayload.isCancelled = sale.isCancelled; 
    
            if(!sale.isCancelled && saleCalculator.isSaleFullyRefunded(sale))
            {
                receiptPrintPayload.isFullyRefunded = true;
            }
    
            receiptPrintPayload.orderNumber = sale.number;
            receiptPrintPayload.tableNumber = sale.tableNumber;
            receiptPrintPayload.venue = sale.venueCode;
            receiptPrintPayload.dispatchType = sale.dispatchType;
            receiptPrintPayload.orderDate = stringUtil.isStringNullOrEmpty(sale.dateTime) ? "N/A" : dateUtil.convertToLocalStandard(sale.dateTime);
            receiptPrintPayload.driverId = sale.driverId;
            receiptPrintPayload.server = sale.server;
            receiptPrintPayload.dispatchInfo = sale.dispatchInfo;
            receiptPrintPayload.noOfGuests = sale.noOfGuests;
            receiptPrintPayload.totalOrderPrice = formatter.convertToCurrencyFormat(saleCalculator.calculateTotalOrderPrice(sale));
            
            var storefront = storefrontUtility.getStorefrontById(sale.storefrontId)
            if(storefront) 
            {
                receiptPrintPayload.propertyId = storefront.propertyId;
                receiptPrintPayload.storefrontId = storefront.id;
                receiptPrintPayload.storefrontName = storefront.name;
            }
    
            var totalServiceCharges = saleCalculator.calculateTotalServiceCharges(sale);
            receiptPrintPayload.totalServiceCharges = totalServiceCharges <= constants.numericThresholdValue ? "" : formatter.convertToCurrencyFormat(totalServiceCharges);
            
            var deliveryCharges = saleCalculator.calculateTotalDeliveryCharges(sale);
            receiptPrintPayload.totalDeliveryCharges = deliveryCharges <= constants.numericThresholdValue ? "" : formatter.convertToCurrencyFormat(deliveryCharges);
    
            var discount = saleCalculator.calculateTotalDiscounts(sale);
            receiptPrintPayload.totalDiscount = discount <= constants.numericThresholdValue ? "" : formatter.convertToCurrencyFormat(discount);
            receiptPrintPayload.discounts = sale.discounts;
    
            receiptPrintPayload.totalPayableAmount = formatter.convertToCurrencyFormat(saleCalculator.calculateTotalNetSalePrice(sale));
    
            var totalVat = saleCalculator.calculateTotalVAT(sale);
            receiptPrintPayload.totalVAT = totalVat > constants.numericThresholdValue ? formatter.convertToCurrencyFormat(totalVat) : null;
            receiptPrintPayload.totalPaidAmount = formatter.convertToCurrencyFormat(sale.paidAmount);
            receiptPrintPayload.paymentMode = stringUtil.isStringNullOrEmpty(sale.paymentMethod) ? "N/A" : sale.paymentMethod;
            receiptPrintPayload.totalRefund = formatter.convertToCurrencyFormat(saleCalculator.calculateTotalRefunds(sale));
            receiptPrintPayload.totalOutstanding = formatter.convertToCurrencyFormat(saleCalculator.calculateRemainingPayableAmount(sale));
            receiptPrintPayload.isPaid = saleCalculator.isSaleFullyPaid(sale);
            receiptPrintPayload.isVatInclusive = localizationUtils.isVatInclusive();
            receiptPrintPayload.isVatApplicable = localizationUtils.isVatApplicable();
            receiptPrintPayload.vatCaption = localizationUtils.getVatCaption();
            
            receiptPrintPayload.receiptLines = [];
            sale.receiptLines.forEach(rL =>
            {
                var receiptLinePrintPayLoad = {};
                receiptLinePrintPayLoad.type = rL.type;
                receiptLinePrintPayLoad.amount = formatter.convertToCurrencyFormat(rL.amount);
                receiptLinePrintPayLoad.paymentMethod = rL.paymentMethod;
                receiptLinePrintPayLoad.line = rL.line;
                receiptPrintPayload.receiptLines.push(receiptLinePrintPayLoad);
    
            })
    
    
            receiptPrintPayload.items = [];
    
            sale.saleItems.forEach (saleItem =>
            {
                addSaleItemInPrintingPayload(saleItem, receiptPrintPayload.items, true);
            });
    
            receiptPrintPayload.endorsements = [];

            await saleEndorsementUtils.applyDeferredEndorsements(sale)
            await receiptEndorsementUtils.applyReceiptEndorsements(sale, receiptPrintPayload)
    
            printUtil.printSaleReceipt(receiptPrintPayload);
        }
        catch(error)
        {
            logger.error(`Error occurred while printing a sale receipt: ${error}`, {}, error)   
        }
}

function addSaleItemInPrintingPayload(saleItem, items, isRootItem)
{
    var title = saleItem.caption;
    if (saleItem.quantity > 1 && localizationUtils.doPrintUnitPriceInSaleReceipt())
    {
        title = `${title}  (@ ${formatter.convertToCurrencyFormat(saleItem.unitPrice)})`;
    }

    var itemPrintPayload = {};
    itemPrintPayload.title = formatSaleItemCaption(saleItem);
    itemPrintPayload.price = formatter.convertToCurrencyFormat(saleItem.unitPrice * saleItem.quantity);
    itemPrintPayload.quantity = isRootItem ? saleItem.quantity : "";
    itemPrintPayload.items = [];
    items.push(itemPrintPayload);

    saleItem.saleItems.forEach (saleSubItem =>
        {
            addSaleItemInPrintingPayload(saleSubItem, itemPrintPayload.items, false);
        });
}

function formatSaleItemCaption(saleItem)
{
    if (saleItem.quantity <= 1 || saleItem.unitPrice <= 0 || !localizationUtils.doPrintUnitPriceInSaleReceipt())
        return saleItem.caption;

    return `${saleItem.caption}  (@ ${formatter.convertToCurrencyFormat(saleItem.unitPrice)})`;
}

export async function printSaleKitchenTicket(sale)
{
    printUtil.printKitchenTicket(sale, 1)
}